// Centrální vrstva nad Shoptet runtime eventy.
// Shoptet překresluje DOM po AJAX (výpis, košík) → samotný DOMContentLoaded nestačí.
// Vše feature-detected: na offline fixture (window.shoptet chybí) se Shoptet hooky prostě nenavážou.

export function onReady(cb) {
  if (document.readyState !== 'loading') cb();
  else document.addEventListener('DOMContentLoaded', cb, { once: true });
}

// Po inicializaci a po AJAX překreslení výpisu/obsahu.
export function onShoptetDom(cb) {
  document.addEventListener('ShoptetDOMContentLoaded', cb);
  document.addEventListener('ShoptetDOMPageContentLoaded', cb);
}

// Změna košíku → counter, mini-cart. detail nese aktuální stav košíku.
export function onCartUpdated(cb) {
  document.addEventListener('ShoptetCartUpdated', function (e) {
    cb((e && e.detail) || cartState());
  });
}

export function hasShoptet() {
  return typeof window.shoptet !== 'undefined';
}

// Čtení klíče ze Shoptet dataLayeru (`cartInfo`, `category`, `customer`, …).
// Primárně přes nativní getShoptetDataLayer, jinak z pole window.dataLayer —
// to je inline v <head> a přežívá i v offline fixtures (dev/*.html), kde
// externí Shoptet JS chybí. Vrací null, když klíč není.
export function shoptetData(key) {
  try {
    if (typeof window.getShoptetDataLayer === 'function') {
      const v = window.getShoptetDataLayer(key);
      if (v != null) return v;
    }
  } catch (e) {
    /* getShoptetDataLayer může házet, když dataLayer ještě není */
  }
  const dl = window.dataLayer;
  if (Array.isArray(dl)) {
    for (let i = dl.length - 1; i >= 0; i--) {
      const s = dl[i] && dl[i].shoptet;
      if (s && s[key] != null) return s[key];
    }
  }
  return null;
}

export function cartState() {
  // Živý Shoptet: ShoptetCartUpdated má detail=null a shoptet.cart zůstává {} —
  // reálný stav nese datalayer (pole položek košíku). shoptet.cart necháváme
  // jako preferenci pro případ, že ho někdy začnou plnit.
  const cart = window.shoptet && window.shoptet.cart;
  if (cart && (cart.itemsCount != null || cart.count != null)) return cart;
  try {
    const items = window.getShoptetDataLayer && window.getShoptetDataLayer('cart');
    if (Array.isArray(items)) {
      return {
        itemsCount: items.reduce(function (n, it) {
          return n + (Number(it.quantity) || 0);
        }, 0),
      };
    }
  } catch (e) {
    /* datalayer nedostupný (offline fixture) */
  }
  return cart || null;
}

// Přidání do košíku VÝHRADNĚ přes Shoptet API (ne vlastní AJAX) — viz CONTEXT.md / plán.
//
// `silent` = druhý argument `cartShared.addToCart`: vypne spinner, na kterém
// visí `getAdvancedOrder()`, takže nevznikne popup „Přidáno do košíku" ani náš
// modal. Na kroku košíku se obsah pak přenačte sám (`handleCartPostUpdate`).
// Ověřeno sondou 2026-09-21 (`ops/sweeps/2026-09-21-kosik-cross-sell-faze0/`,
// cesta A). Bez `silent` se druhý argument nepředává vůbec, ostatní volající
// se chovají jako dřív.
export function addToCart(payload, silent) {
  if (window.shoptet && window.shoptet.cartShared && typeof window.shoptet.cartShared.addToCart === 'function') {
    if (silent) window.shoptet.cartShared.addToCart(payload, true);
    else window.shoptet.cartShared.addToCart(payload);
    return true;
  }
  return false;
}

// „Kolik zbývá do prahu" z `cartInfo.leftToFreeShipping` / `leftToFreeGift`.
//
// PAST: obal je vždycky OBJEKT, i když práh v tomhle košíku neexistuje —
// nadrozměrný košík vrací `{ priceLeft: null, formattedPrice: null }`
// (spolu s `freeShippingFrom: null`). Naivní `Number(obj.priceLeft)` z toho
// udělá **0**, což čtenář vyhodnotí jako „práh dosažen" a slíbí dopravu
// zdarma tam, kde žádná není (bug modalu „Přidáno do košíku", 2026-08-25).
// Proto: null/prázdno = NEZNÁMO (NaN), ne nula.
export function cartLeft(info, key) {
  const box = info && info[key];
  if (!box) return NaN;
  const raw = box.priceLeft;
  if (raw == null || raw === '') return NaN;
  const n = Number(raw);
  return Number.isFinite(n) ? n : NaN;
}
